import memberships from "../models/Memberships";

const subscriptions = memberships.memberships

const SubscriptionTypeToString = (_type) => {
     for (let _sub in subscriptions) {
         if (subscriptions[_sub].id === _type) return subscriptions[_sub].name
     }
     return ""
}

const SubscriptionLengthToDays = (_length) => {
    if (_length && _length) return _length / 86400
    else return ""
}

const getTierDisplayName = (tier) => {
    if (tier === undefined || tier === null) return "N/A"
    if (typeof tier === "string") {
        return tier.charAt(0).toUpperCase() + tier.slice(1).toLowerCase()
    }
    const name = SubscriptionTypeToString(tier)
    return name ? name.charAt(0).toUpperCase() + name.slice(1) : "N/A"
}

const getTierBadgeClass = (tier) => {
    let name = "bronze"
    if (typeof tier === "string") {
        name = tier.toLowerCase()
    } else if (tier !== undefined && tier !== null) {
        name = SubscriptionTypeToString(tier).toLowerCase() || "bronze"
    }
    return `subscription-container membership-tier-badge ${name}`
}

const getTierMismatchNote = (actualTier, paidTier, verified, accredDeclined, expired) => {
    const notes = []
    const isExpired = Boolean(expired)

    if (isExpired) {
        notes.push("This user's paid subscription has expired. The cached subscription may still show the previous tier until it is refreshed.")
    }

    if (actualTier === undefined || actualTier === null || paidTier === undefined || paidTier === null) {
        return notes.length ? notes : null
    }
    if (actualTier === paidTier) {
        return notes.length ? notes : null
    }

    if (accredDeclined === 1) {
        notes.push("This user has paid for a higher tier but accreditation was declined. Site access remains at the cached subscription level.")
        return notes
    }
    if (!verified && paidTier > 0) {
        notes.push("This user has paid for a higher tier and is waiting on accreditation. Site access is limited to the cached subscription level until approved.")
        return notes
    }
    if (!isExpired) {
        notes.push("Cached and paid membership tiers differ. If the user is accredited, this may indicate a display sync issue.")
    }
    return notes.length ? notes : null
}

export default {
    SubscriptionTypeToString,
    SubscriptionLengthToDays,
    getTierDisplayName,
    getTierBadgeClass,
    getTierMismatchNote,
}